RA.ViewKB = {
  init() {
    if (this.user && !this.user.isGuest) {
      ReactDOM.render(
        <Favorite />,
        document.getElementById("favAction")
      );
    }

    ReactDOM.render(
      <SolutionFeedback
        viewCount={RA.ViewKB.stats.views}
        initalSolvedCount={RA.ViewKB.stats.solved} />,
      document.getElementById("solutionFeedback")
    );

    if (this.config && this.config.showComments) {
      this.Comments.load();
    }

    this.initImageResize();
    this.initTranslations();
    this.initRelatedTitles();
    this.initContentBlocks();
    this.initLogLinks();
    this.RightPath.init(this.user);
    this.initSelectpicker();

    this.initMailToLink();
    this.initDiagBackAction();
  },
  initMailToLink() {
	let addData = {
	 solutionID: RA.ViewKB.solution.id,
	 solutionTitle: RA.ViewKB.solution.title,
	 type: "regular",
	 SToken: Config.csrf.value
	};

	RAEmail.init(addData);
  },
  initDiagBackAction() {
    $("#diagBack").click( function(e) {
        e.preventDefault();

        var url = Config.contextPath + "/app/core/remove-dt-capture.jsp";
        var data = { SToken: Config.csrf.value };
        $.post(url, data)
          .always(function() {
            window.history.go( -1 );
          });
      });
  },
  initImageResize() {
      // Resize images and add listener to resize images on window resize
      // using img load event is inconsistent cross-browser. Using timeout.
      setTimeout(this.resizeImages, 250);

      $(window).resize(debounce(this.resizeImages, 200));
  },
  resizeImages() {
   $(".solution-content img").each(function() {
      var $img = $(this);
      var $container = $(".solution-content");
      var maxWidth = $container.width();
      var fullWidth = $img.data("fullWidth");
      if (!fullWidth) {
        $img.data("fullWidth", $img.width());
        fullWidth = $img.width();
      }

      if ($img.width() > maxWidth) {
        $img.width(maxWidth);
        $img.attr("height", null).css("height", "auto");
      } else if ($img.width() < fullWidth) {
        $img.width(Math.min(fullWidth, maxWidth));
      }
    });
  },
  initTranslations() {
    let $select = $("#translationSelect");

    $select.on("change", function() {
      location.href = "viewsolution.jsp?solutionid=" + $select.val() + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    });
  },
  initRelatedTitles() {
    let $links = $("#relatedTitlesList a[data-taxonomy]");

    $links.each(function() {
      let $link = $(this);
      let taxPath = $link.data("taxonomy");
      $link.attr("href", `${Config.contextPath}/${Config.portalInterface}/?taxonomypath=${encodeURIComponent(taxPath)}&tabid=${Config.resultsTabID}#t=kbResults`);
    });
  },
  initContentBlocks() {
    $("[data-cb-collapsed]").wrap("<a data-cb-collapsed-anchor='true' href='#'></a>");
    $("[data-cb-collapsed-anchor]").on("click", function(){
      $(this).next("div").collapse('toggle');
    });
    var $cParent = $("[data-cb-collapsed='true']").parent();	
	$cParent.next("div").removeClass('in');
	$cParent.next("div").addClass('collapse');
	
	var $eParent = $("[data-cb-collapsed='false']").parent();	
	$eParent.next("div").collapse('toggle');
  },
  initLogLinks() {
    $("[data-log]").on("click", function(e) {
      let $link = $(e.currentTarget);
      let action = $link.data("log");
      RA.ViewKB.logAction(action);
    });
  },
  logAction(action) {
    RA.logAction(RA.ViewKB.getLogString(action));
  },
  getLogString(action) {
    let $logForm = $("#logform");
    let $accessmethod = $logForm.find("[name=accessmethod]");
    let $action = $logForm.find("[name=action]");

    if ($action.length) {
      $action.val(action);
    }
    $accessmethod.val(sessionStorage.getItem("accessmethod"));

    return $logForm.serialize();
  },
  Comments: {
    currentPage: 1,
    load(pageNumber) {
      if (arguments.length == 0) {
        pageNumber = 1;
      }

      let url = Config.contextPath + "/controller/get/solution/comment/";
      let data = {
        solutionID: RA.ViewKB.solution.id,
        page: pageNumber
      };
      this.currentPage = pageNumber;

      $.get(url, data)
        .done(r => {
          this.show(r)
        });
    },
    show(data) {
      ReactDOM.render(
        <SolutionComments data={data}
          isGuest={RA.ViewKB.user.isGuest} />,
        document.getElementById("comments")
      );

      ReactDOM.render(
        <CommentCountAction count={data.totalComments} />,
        document.getElementById("commentAction")
      );
    },
    add(comment, cb) {
      let isFromDiagnostic = false;
      let windowUrl = window.location.href;
      if (windowUrl.indexOf("isfromdiagnostic=true") >= 0) {
        isFromDiagnostic = true;
      }

      let url = Config.contextPath + "/controller/saveComment/solution/comment/";
      let data = {
        SToken: Config.csrf.value,
        comments: comment.text,
        parentID: comment.parentID,
        solutionID: RA.ViewKB.solution.id,
        isfromdiagnostic: isFromDiagnostic,
        mentionedUsersList: comment.mentionedUsersList
      };

      RA.ViewKB.logAction("SUBMITNOTE");

      $.post(url, data)
        .done(res => {
          if (cb) cb(res)
      });
    },
    scrollTo() {
      let scrollTop = $("#comments").offset().top - 100;
      window.scrollTo(0, scrollTop);
    }
  },
  RightPath: {
    init(user) {
      var idPrefix = "solcheck";
      var $checks = $("[id^=" + idPrefix + "]");
      var totalChecks = $checks.length;

      if (totalChecks == 0) {
        return;
      }

      if (user && user.isGuest) {
		$checks.each(function(){
			$(this).attr("disabled", true);
		});

        return;
      }

      this.load();

      $checks.on("change", debounce(this.save, 500));
    },
    load() {
      var $usernameToCheck = $("#usernametocheck_sol");
      var idPrefix = "solcheck";
      var $checks = $("[id^=" + idPrefix + "]");
      var totalChecks = $checks.length;

      if (totalChecks == 0) {
        return;
      }

      var solutionID =  document.logform.docid.value;
      var data = { operation: "query",
        solutionid: solutionID,
		SToken: Config.csrf.value};

      if ($usernameToCheck.length) {
        data["usernametocheck"] = $usernameToCheck.val();
      }

      var url = Config.contextPath + "/app/core/solchecks.jsp";

      $.post(url, data)
        .done( function(r) {
          r = $.trim(r);
          var checkedSteps = r.split(";");

          $.each(checkedSteps, function(index, value) {
            $("#" + idPrefix + value).prop("checked", true);
          });
        });
    },
    save() {
      var $usernameToCheck = $("#usernametocheck_sol");
      var idPrefix = "solcheck";
      var $checks = $("[id^=" + idPrefix + "]");
      var totalChecks = $checks.length;

      if ($usernameToCheck.length > 0 || totalChecks == 0) {
        return;
      }

      var solutionID =  document.logform.docid.value;
      var solutionTitle =  document.logform.description.value;

      var checkedSteps = $checks.filter(":checked").map( function() {
        var id = $(this).attr("id");
        return id.substring(idPrefix.length);
      }).get();


      var operation = checkedSteps.length ? "insert" : "delete";
      var data = { operation: operation,
          solutionid: solutionID,
          solutiontitle: solutionTitle,
          stepscompleted: checkedSteps.join(";"),
          numberofsteps: totalChecks
      };

      var url = Config.contextPath + "/app/core/solchecks.jsp?SToken=" + Config.csrf.value;
      $.post(url, data);
    }
  },
  initSelectpicker() {
      try {
          $("#translationSelect").selectpicker('refresh');
      } catch (e) {
          //Do nothing in case bootstrap-select library is not found.
      }
  }
};